import { gql } from '@apollo/client';

// Roles

export const FETCH_USER_ROLES = gql`
  query GetUserRoles {
    userRoles
  }
`;

// Lookups
export const FETCH_STATUSES_QUERY = gql`
  query GetWorkInProgressStatuses {
    workInProgressStatuses {
      id
      title
    }
  }
`;

export const FETCH_ORGANISATIONS_QUERY = gql`
    query GetOrganisations {
        organisations {
            id
            organisationName
          }
    }
`;

export const FETCH_LIFECYCLE_STAGE_QUERY = gql`
query GetRepairLifecycleStages {
  repairLifecycleStages {
    id
    title
  }
}
`;


export const FETCH_PLANNER_GROUPS_QUERY = gql`
    query GetPlannerGroups {
      plannerGroups {
        id
        title
      }
    }
`;

export const FETCH_CONTRACTS_QUERY = gql`
    query GetContracts {
      contracts {
        id
        title
        productId
      }
    }
`;

export const FETCH_ORGANISATION_CONTRACTS_QUERY = gql`
    query GetOrganisationContracts ($organisationId: ID!) {
        contractsByOrganisationId(id: $organisationId) {
            id
            title
            productId
        }
    }
`;

export const FETCH_CONTRACT_PARTS_QUERY = gql`
    query GetContractParts ($contractId: ID!) {
      partsForContractId(id: $contractId) {
        partNumber
        description
      }
    }
`;

export const FETCH_PARTS_QUERY = gql`
    query GetParts {
        parts {
            partNumber
            description
        }
    }
`;

export const FETCH_PART_ASSETS_QUERY = gql`
    query GetPartAssets($partId: String!) {
        assetsByPartNumber(partNumber: $partId) {
            id
            serialNumber
        }
    }
`;

export const FETCH_COURIERS_QUERY = gql`
    query GetCouriers {
        couriers {
            id
            title
        }
    }
`;

export const FETCH_INTENTIONS_QUERY = gql`
    query GetIntentions {
        intentions {
            id
            title
            isEnabled
         }
    }
`;

export const FETCH_ROLES_QUERY = gql`
  query GetRoles {
    roles {
      id
      title
    }
  }
`

// Entities

// History

export const FETCH_HISTORY_FOR_GRID = gql`
  query GetHistory($skip: Int, $take: Int, $order: [ChangeHistoryGridModelSortInput!], $filters: ChangeHistoryGridFiltersModelInput) {
    changeHistoryForGrid (skip: $skip, take: $take, order:  $order, filters: $filters) {
      pageInfo {
        hasPreviousPage
        hasNextPage
      }
      totalCount
      items {
        id
        createdDate
        createdByName
        fieldName
        oldValue
        newValue
      }
    }
  }`

// Users

export const FETCH_USERS_FOR_GRID = gql` 
  query GetUserGrid($skip: Int, $take: Int, $order: [UserGridModelSortInput!], $filters: UserGridFiltersModelInput!) {
    userGrid (skip: $skip, take: $take, order:  $order, filters: $filters) {
      pageInfo {
        hasPreviousPage
        hasNextPage
      }
      totalCount
      items {
        id
        userName
        firstName
        lastName
        email
        officePhone
        mobilePhone
        createdDate
        numberOfRoles
        numberOfContracts
      }
    }
  }
`

export const FETCH_USER_BY_ID = gql`
  query GetUserById($id: UUID!) {
    user(id: $id) {
      userName
        firstName
        lastName
        email
        officePhone
        mobilePhone
        createdDate
        roles {
          id
          title
        } 
        contracts {
          id
          title
      }
    }
  }
`

// Shipment Notifications

export const FETCH_NOTIFICATIONS_FOR_GRID_QUERY = gql`
query GetNotificationsForGrid($skip: Int, $take: Int, $order: [ShippingNotificationGridModelSortInput!], $filters: ShippingNotificationGridFiltersModelInput) { 
  shippingNotificationsForGrid ( skip: $skip, take: $take, order: $order, filters: $filters ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
    }
    totalCount
    items {
      id
      serialNumber
      contractTitle
      partNumber
      assetSerialNumber
      assetId
      createdDate
      createdByName
      isClosed
      workInProgressId
      workInProgressSerialNumber
    }
  }
}`

export const CAN_CREATE_SHIPPING_NOTIFICATION_QUERY = gql`
  query CanCreateShippingNotification($input: ExistingShippingNotificationInputModelInput!) {
    canCreateShippingNotification (input: $input)     
  }
`;


export const FETCH_NOTIFICATION_BY_ID_QUERY = gql`
query GetNotificationById($id: ID!) {
  shippingNotificationById (id: $id) {
      id
      serialNumber
      createdDate
      createdByName
      lastModifiedDate
      lastModifiedByName
      isClosed
      workInProgress {
        serialNumber
        id
      }
      contract {
        id
        title
        organisation {
          id
          organisationName
        }
      }
    asset {
      id
      serialNumber
      part {
        partNumber
        description
        plannerGroup {
          title
        }
      }
    }
      courier {
        id
        title
      }
      courierTrackingNumber
      courierTrackingUrl
      shippingDate
      expectedDeliveryDate
      intention {
        id
        title
      }
      symptoms
  }
}
`;

// WIPS

export const FETCH_WIPS_FOR_GRID_QUERY = gql`
query GetWIPsForGrid($skip: Int, $take: Int, $order: [WorkInProgressGridModelSortInput!], $filters: WorkInProgressGridFiltersModelInput) {
  workInProgressForGrid(skip: $skip, take: $take, order: $order, filters: $filters) {
    pageInfo {
      hasPreviousPage
      hasNextPage
    }
    totalCount
    items {
      id
      salesOrder
      serviceOrder
      contractTitle
      partNumber
      assetSerialNumber
      createdDate
      shippedStatus
      shippedDate
      currentRepairLifecycleStageTitle
      status
    }
  }
}`

export const FETCH_WIP_BY_ID_QUERY = gql`
query GetWIPById($id: ID!) {
  workInProgressById(id: $id) {
    id
    createdDate
    lastModifiedDate
    status {
      title
    }
    currentRepairLifecycleStage {
      title
    }
    shippingNotification {
      id
    }
    salesOrder
    serviceOrder
    contract {
      id
      title
      organisation {
        id
        organisationName
      }
      product {
        id
        title
      }
    }
    asset {
      id
      serialNumber
      part {
        partNumber
        description
        plannerGroup {
          title
        }
      }
    }
    receivedAtGoodInStatusText,
    goodsReceivedInDate

    surveyCompletedStatusText
    surveyCompletedDate

    customerPlannedAcceptedWorkStatusText
    customerAcceptedWorkDate

    serviceWorkScheduledStatusText
    serviceWorkScheduledDate

    serviceWorkStartedStatusText
    serviceWorkStartedDate

    serviceWorkAcceptedStatusText
    serviceWorkAcceptedDate

    receivedAtGoodOutStatusText
    goodsReceivedOutDate

    shippedStatusText
    shippedDate
    escalation {
      id
      serialNumber
    }

  }
}
`;

//Escalations
export const FETCH_ESCALATION_BY_ID_QUERY = gql`
query getEscalationById($id: ID!) {
  escalationById(id: $id) {
    id
    asset {
      id
      serialNumber
      part {
        partNumber
        description
        plannerGroup {
          title
        }
      }
    }
    isClosed
    contract {
      id
      title
      product {
        title
      }
      organisation {
        id
        organisationName
      }
    }
    workInProgress {
      id
      serialNumber
    }
    createdByName
    lastModifiedByName
    createdDate
    lastModifiedDate
    serialNumber
  }
}`;

export const FETCH_ESCALATIONS_FOR_GRID_QUERY = gql`
query GetEscalationssForGrid($skip: Int, $take: Int, $order: [EscalationGridModelSortInput!], $filters: EscalationGridFiltersModelInput) {
  escalationsForGrid(skip: $skip, take: $take, order: $order, filters: $filters) {
    pageInfo {
      hasPreviousPage
      hasNextPage
    }
    totalCount
    items {
      id
      serialNumber
      contractTitle
      partNumber
      assetSerialNumber
      createdDate
      createdByName
      isClosed
      workInProgressId
      workInProgressSerialNumber
    }
  }
}`


// Comments

export const FETCH_COMMENTS = gql`
  query GetComments($entityId: ID!, $context: String!, $order: [CommentSortInput!], $skip: Int, $take: Int) {
    commentsByEntityIdAndContext(entityId: $entityId, context: $context, order: $order, skip: $skip, take: $take) {
      totalCount
      items {
        id
        createdByName
        createdDate
        value
      }
    }
  }
`;

export const FETCH_COMMENTS_COUNT = gql`
  query GetCommentsCount($entityId: ID!, $context: String!) {
    commentsByEntityIdAndContext(entityId: $entityId, context: $context) {
      totalCount
    }
  }
`;

// Dashboard

export const FETCH_DASHBOARD_COUNTS_BY_CONTRACTS = gql`
  query GetTabularDashBoardCounts($contractIds: [ID!]!) {
    tabularDashboardCounts(contractIds: $contractIds) {
      total
      numberOfSNs
      numberOfWIPs
      numberOfEscalatedWIPs
      numberOfShippedWIPs
      repairLifeCycleStageCount
      hasRepairLifeCycleStageEscalations
    }
  }`

  export const FETCH_DASHBOARD_GRID_QUERY = gql`
    query GetDashboardGrid($order: [TabularDashboardGridModelSortInput!], $skip: Int, $take: Int, $filters: TabularDashboardGridFiltersModelInput!) {
      tabularDashboardGrid(order: $order, skip: $skip, take: $take, filters: $filters ) {
        pageInfo {
          hasPreviousPage
          hasNextPage
        }
        totalCount
        items {
          id
          escalationId
          shippingNotificationId
          contractTitle
          partNumber
          assetSerialNumber 
          currentRepairLifeCycleStageTitle
          daysAtCurrentLifeCycleStage
          currentForecastShippingDate
          originalShippingDate
          hasShippingNotification
          numberOfShippingNotificationComments
          hasEscalation
          numberOfEscalationComments
          escalatedForecastShippingDateImpact
          type
        }
      }
    }
  `

  //ImportAudit

  export const  FETCH_IMPORTAUDIT_FOR_GRID_QUERY = gql`
    query GetImportAudit
    {
      importAudits
      {
        id
        importDate
        recordsImported
        recordsAdded
        recordsUpdated
        errors
      }
    } ` ;
// MUTATIONS

export const CREATE_NOTIFICATION_MUTATION = gql`
  mutation AddNotification($input: CreateShippingNotificationInput!) {
    createShippingNotification(input: $input) {
      shippingNotification {
        id
        courierTrackingNumber
        courierTrackingUrl
        shippingDate
        expectedDeliveryDate
        symptoms
        createdDate
        createdByName
        lastModifiedDate
        lastModifiedByName
        asset {
          id
          serialNumber
          partNumber
        }
        contract {
          id
          title
          organisation {
            id
            organisationName
          }
        }
        courier {
          id
          title
        }
        intention {
          id
          title
        }
      }
    }
  }
`;

export const UPDATE_NOTIFICATION_MUTATION = gql`
  mutation UpdateNotification($input: UpdateShippingNotificationInput!) {
    updateShippingNotification(input: $input) {
      shippingNotification {
        id
        courierTrackingNumber
        courierTrackingUrl
        shippingDate
        expectedDeliveryDate
        symptoms
        createdDate
        createdByName
        lastModifiedDate
        lastModifiedByName
        asset {
          id
          serialNumber
          partNumber
        }
        contract {
          id
          title
          organisation {
            id
            organisationName
          }
        }
        courier {
          id
          title
        }
        intention {
          id
          title
        }
      }
    }
  }
`;

export const CREATE_COMMENT_MUTATION = gql`
    mutation AddComment($input: CreateCommentInput!) {
      createComment(input: $input) {
        comment {
          id
          createdByName
          createdDate
          value
        }
      }
    }
`;

export const CREATE_ESCALATION_MUTATION = gql`
    mutation CreateEscalation($input: CreateEscalationInput!) {
      createEscalation(input: $input) {
        escalation {
          id
          asset {
            id
            serialNumber
            part {
              partNumber
              description
              plannerGroup {
                title
              }
            }
          }
          isClosed
          contract {
            id
            title
            product {
              id
              title
            }
            organisation {
              id
              organisationName
            }
          }
          workInProgress {
            id
            serialNumber
          }
          createdByName
          lastModifiedByName
          createdDate
          lastModifiedDate
          serialNumber
        }
      }
    }
`;

export const UPDATE_USER_MUTATION = gql`
  mutation UpdateUser($input: UpdateUserInput!)  {
    updateUser(input: $input) {
      userModel {
        userName
        contracts {
          id
          title
        }
        roles {
          id
          title
        }
      }
    }
  }
`
